import { FormikProps } from "formik";
import { ReactNode, useContext } from "react";
import { AvisContext } from "../../../../context/AvisContext";
import { ScrollToFieldError } from "../../../../formik/ScrollToFieldError";
import { AvisModal } from "../../../modal";
import { useAtom } from "jotai";
import { atomIsModalOpen } from "../../atoms";

interface IAvisEditableListModalFormProps<P extends object> {
  formikProps: FormikProps<P>;
  editMode: boolean;
  disabled?: boolean;
  title?: string;
  renderInnerForm?: (fBag: FormikProps<P>) => ReactNode;
}
export function AvisEditableListModalForm<P extends object>(
  props: Readonly<IAvisEditableListModalFormProps<P>>,
) {
  const { formikProps, editMode, title, disabled, renderInnerForm } = props;

  const { res } = useContext(AvisContext);
  const [isModalOpen, setIsModalOpen] = useAtom(atomIsModalOpen);

  if (!renderInnerForm) return null;

  return (
    <>
      <AvisModal
        isOpen={isModalOpen}
        title={title}
        hideConfirm={disabled}
        confirmButtonText={editMode ? res("button_Edit") : res("button_Add")}
        onConfirm={formikProps.submitForm}
        onClose={() => setIsModalOpen(false)}
      >
        {renderInnerForm(formikProps)}
      </AvisModal>
      <ScrollToFieldError />
    </>
  );
}
